import cellRenderer from './cellRenderer'
import cellEditor from './cellEditor'

export default { cellRenderer, cellEditor }
